/* eslint-disable react-hooks/exhaustive-deps */
import React, { forwardRef, useEffect, useLayoutEffect, useRef } from "react";
import "quill/dist/quill.snow.css";
import Quill from "quill";
import clsx from "clsx";

const BASIC_TOOLBAR = [["bold", "italic", "underline"], ["link"], [{ list: "ordered" }, { list: "bullet" }]];

const FULL_TOOLBAR = [
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    ["bold", "italic", "underline", "strike"],
    ["blockquote"],
    ["link"],
    [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
    [{ indent: "-1" }, { indent: "+1" }],
    [{ align: [] }],
    [{ color: [] }, { background: [] }],
];

const RichTextEditorHTML = forwardRef(
    ({ readOnly, defaultValue, onTextChange = () => {}, label, error, helperText, placeholder, basicToolbar = false }, ref) => {
        const containerRef = useRef(null);
        const onTextChangeRef = useRef(onTextChange);
        const hasError = Boolean(error);
        const hText = error || helperText;

        useLayoutEffect(() => {
            onTextChangeRef.current = onTextChange;
        });

        useEffect(() => {
            const container = containerRef.current;
            const editorContainer = container.appendChild(container.ownerDocument.createElement("div"));

            const quill = new Quill(editorContainer, {
                readOnly: readOnly,
                modules: {
                    toolbar: readOnly ? null : basicToolbar ? BASIC_TOOLBAR : FULL_TOOLBAR,
                },
                placeholder: readOnly ? undefined : placeholder,
                theme: "snow",
            });

            // Hacemos que la instancia de Quill esté disponible fuera del componente
            if (ref) {
                ref.current = quill;
            }

            quill.clipboard.dangerouslyPasteHTML(0, defaultValue);

            // CAMBIO 2: Usar quill.root.innerHTML para obtener el contenido como HTML en cada cambio.
            quill.on(Quill.events.TEXT_CHANGE, (delta, oldDelta, source) => {
                // Solo actualizamos si el cambio proviene del usuario para evitar bucles
                if (source === "user") {
                    const html = quill.root.innerHTML;
                    // Quill considera un editor vacío como '<p><br></p>', lo normalizamos a un string vacío.
                    if (html === "<p><br></p>") {
                        onTextChangeRef.current?.("");
                    } else {
                        onTextChangeRef.current?.(html);
                    }
                }
            });

            return () => {
                if (ref) {
                    ref.current = null;
                }
                container.innerHTML = "";
            };
        }, [ref, readOnly, defaultValue]);

        return (
            <div>
                {label && <label>{label}</label>}
                <div ref={containerRef}></div>
                {hText && <p className={clsx({ error: hasError, helperText: !hasError })}>{hText}</p>}
            </div>
        );
    }
);

export default RichTextEditorHTML;
